import React from "react";
import { useStore } from "mcmap-lib";

const inputStyles = "border-2 border-gray-300 rounded-md p-1 w-full";
const labelStyles = "flex-1 mr-1";
const rowStyles = "flex items-center justify-between pb-1 my-1";

export default function UserForm({ user, setUser, isLoading, setIsValid }) {
  const config = useStore((state) => state.config);
  const [errorMessage, setErrorMessage] = React.useState("");
  const checkFormValidity = (newUser) => {
    setIsValid(false);

    if (newUser.UserName === "") {
      setErrorMessage("Username is required");
      return;
    }
    if (newUser.FirstName === "") {
      setErrorMessage("First Name is required");
      return;
    }
    if (newUser.LastName === "") {
      setErrorMessage("Last Name is required");
      return;
    }
    if (newUser.Title === "") {
      setErrorMessage("Title is required");
      return;
    }
    if (newUser.Agency === "") {
      setErrorMessage("Agency is required");
      return;
    }
    if (newUser.PhoneNumber === "") {
      setErrorMessage("Phone Number is required");
      return;
    }
    if (newUser.Email === "") {
      setErrorMessage("Email is required");
      return;
    }
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newUser.Email);
    if (!isValidEmail) {
      setErrorMessage("Email is not valid");
      return;
    }
    if (newUser.Roles.length === 0) {
      setErrorMessage("At least one role is required");
      return;
    }
    setIsValid(true);
    setErrorMessage("");
  };
  const handleChange = (e) => {
    const newUser = { ...user, [e.target.name]: e.target.value };
    setUser(newUser);
  };

  React.useEffect(() => {
    checkFormValidity(user);
  }, [user]);

  return (
    <form
      className={`w-100 mx-2 ${
        isLoading === true ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <label className={labelStyles}>
        <span className="block">UserName</span>
        <input
          disabled={isLoading}
          required
          className={inputStyles}
          type="text"
          name="UserName"
          onChange={handleChange}
          value={user?.UserName}
        />
      </label>
      <div className={rowStyles}>
        <label className={labelStyles}>
          <span className="block">First Name</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="FirstName"
            onChange={handleChange}
            value={user?.FirstName}
          />
        </label>
        <label className={labelStyles}>
          <span className="block">Last Name</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="LastName"
            onChange={handleChange}
            value={user?.LastName}
          />
        </label>
      </div>
      <div className={rowStyles}>
        <label className={labelStyles}>
          <span className="block">Title</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="Title"
            onChange={handleChange}
            value={user?.Title}
          />
        </label>
        <label className={labelStyles}>
          <span className="block">Agency</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="Agency"
            onChange={handleChange}
            value={user?.Agency}
          />
        </label>
      </div>
      <div className={rowStyles}>
        <label className={labelStyles}>
          <span className="block">Phone Number</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="PhoneNumber"
            onChange={handleChange}
            value={user?.PhoneNumber}
          />
        </label>
        <label className={labelStyles}>
          <span className="block">Email</span>
          <input
            disabled={isLoading}
            required
            className={inputStyles}
            type="text"
            name="Email"
            onChange={handleChange}
            value={user?.Email}
          />
        </label>
      </div>
      <label className={labelStyles + " flex items-center"}>
        <input
          disabled={isLoading}
          required
          className="checkbox checkbox-xs"
          type="checkbox"
          name="Active"
          onChange={() => setUser({ ...user, Active: !user?.Active })}
          checked={user?.Active}
        />
        <span className="ml-2 hover:underline cursor-pointer">Is Active</span>
      </label>
      <p className="text-md mt-2">Role(s)</p>
      {config?.authenticationService?.allowedUserRoles?.map((role) => (
        <label key={role} className={labelStyles + " flex items-center"}>
          <input
            disabled={isLoading}
            required
            className="checkbox checkbox-xs"
            type="checkbox"
            name="Roles"
            onChange={(e) => {
              if (e.target.checked) {
                setUser({ ...user, Roles: [...user?.Roles, role] });
              } else {
                setUser({
                  ...user,
                  Roles: user?.Roles.filter((r) => r !== role),
                });
              }
            }}
            checked={user?.Roles?.includes(role)}
          />
          <span className="ml-2 hover:underline cursor-pointer">{role}</span>
        </label>
      ))}
      {errorMessage.length > 0 && (
        <p className="text-red-700 text-sm mt-2 bg-red-200 p-2">
          {errorMessage}
        </p>
      )}
    </form>
  );
}
